import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { MatButtonModule} from '@angular/material/button';
import { MatSelectModule } from '@angular/material/select';
import { MatProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/progress-spinner';

import { CompassLibraryManageDialog } from './compass-library-manage-dialog.component';
import { ListingModule } from '../listing/listing.module';
import { DirectivesModule } from '../../directives/directive.module';
import { VarModule } from '../../directives/ngVar';

@NgModule({
  declarations: [
    CompassLibraryManageDialog
  ],
  imports: [
    CommonModule,
    FormsModule,
    MatButtonModule,
    MatSelectModule,
    MatProgressSpinnerModule,
    ListingModule,
    DirectivesModule,
    VarModule
  ],
  exports: [
    CompassLibraryManageDialog
  ]
})
export class CompassLibraryManageDialogModule {}
